export enum Icon {
	home = 'mdi-gauge',

	create = 'mdi-plus',
	edit = 'mdi-pencil',
	delete = 'mdi-delete',
	view = 'mdi-eye',
	copy = 'mdi-content-copy',
	search = 'mdi-magnify',
	archive = 'mdi-archive',
	unarchive = 'mdi-archive',
	select = 'mdi-check-bold',
	unselect = 'mdi-close-thick',
	accordionToggle = 'mdi-chevron-down-circle',
	open = 'mdi-chevron-down',
	close = 'mdi-close-thick',
	clear = 'mdi-close-thick',
	filter = 'mdi-filter',
	list = 'mdi-format-list-bulleted-square',
	avatar = 'mdi-camera-account',
	image = 'mdi-file-image',
	settings = 'mdi-hammer-wrench',
	menu = 'mdi-dots-vertical',
	yes = 'mdi-check-bold',
	no = 'mdi-close-thick',
	login = 'mdi-key',
	logout = 'mdi-key',
	download = 'mdi-download',
	save = 'mdi-content-save',
	adopt = 'mdi-check-bold',
	cancel = 'mdi-close',
	showPassword = 'mdi-eye',
	hidePassword = 'mdi-eye-off',
	alert = 'mdi-alert',
	confirm = 'mdi-alert',
	username = 'mdi-account',
	password = 'mdi-key',
	private = 'mdi-home',
	system = 'mdi-code-json',
	created = 'mdi-asterisk',
	updated = 'mdi-wrench',
	previous = 'mdi-chevron-left',
	next = 'mdi-chevron-right',
	date = 'mdi-calendar',
	time = 'mdi-clock',
	break = 'mdi-coffee',
	licensePlate = 'mdi-numeric',
	state = 'mdi-circle',
	send = 'mdi-send',
	print = 'mdi-printer',
	log = 'mdi-console',

	report = 'mdi-file-document',
	reports = 'mdi-file-document-multiple',
	reportLine = 'mdi-clipboard-list',
	reportLines = 'mdi-clipboard-list',
	company = 'mdi-office-building',
	companies = 'mdi-office-building',
	companyInternal = 'mdi-chair-rolling',
	companyCustomer = 'mdi-dump-truck',
	user = 'mdi-account',
	users = 'mdi-account-group',
	order = 'mdi-dump-truck',
	orders = 'mdi-dump-truck',
	bill = 'mdi-cash',
	bills = 'mdi-cash-multiple',
	planning = 'mdi-calendar-month',
	planningEntry = 'mdi-clipboard-flow',
	planningEntries = 'mdi-clipboard-flow',

	name = 'mdi-tag-text',
	notes = 'mdi-notebook',
	rate = 'mdi-cash',
	rateHour = 'mdi-clock-time-three-outline',
	rateDay = 'mdi-hours-24',
	export = 'mdi-database-export',
	address = 'mdi-map-marker',
	email = 'mdi-email',
	phone = 'mdi-phone',
	employmentType = 'mdi-fountain-pen-tip',
	rights = 'mdi-lock',
	birthday = 'mdi-cake-variant',
	gender = 'mdi-gender-male-female',
	language = 'mdi-chat-processing',
	country = 'mdi-earth',
	infos = 'mdi-information',
	contactEntries = 'mdi-radio-tower',

}
